import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondToTimeStructured'
})
export class SecondToTimeStructuredPipe implements PipeTransform {



  transform(input) {
    const sgn = Math.sign(input);
    input = Math.abs(input);
    if (input) {
      const sec_num = parseInt(input, 10); // don't forget the second param
      let hours = Math.floor(sec_num / 3600);
      let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      let seconds = sec_num - (hours * 3600) - (minutes * 60);
      let output: String;
      hours = this.checkDigit(hours);
      minutes = this.checkDigit(minutes);
      seconds = this.checkDigit(seconds);
      output = `${sgn === -1 ? '-' : ''}${hours > 0 ? `${hours}:` : ''}${minutes > 0 ? `${minutes}:` : ''}${seconds}`;
      return output;
    } else {
      return null;
    }
  }
  checkDigit(num) {

    if (num < 10) {
      return '0' + num;
    } else {
      return num;
    }
  }

}
